document.addEventListener('DOMContentLoaded', () => {
  const main = document.querySelector('#main');

  let lastScrollTop = 0;
  let scrollDownDistance = 0;
  let scrollUpDistance = 0;
  document.addEventListener(
    'scroll',
    function (e) {
      const st = window.pageYOffset || document.documentElement.scrollTop;

      // Programmatic scrolls manage menu compaction themselves
      if (main.classList.contains('is-programmatic-scroll')) {
        lastScrollTop = st <= 0 ? 0 : st;
        scrollDownDistance = 0;
        scrollUpDistance = 0;
        return;
      }

      if (st > lastScrollTop) {
        scrollUpDistance = 0;
        scrollDownDistance += st - lastScrollTop;
        if (scrollDownDistance > 1000) {
          if (main.classList.contains('is-menu-open') !== true) {
            // document.querySelector('#main').classList.add('is-menu-compacted');
          }
        }
      } else {
        scrollDownDistance = 0;
        scrollUpDistance += st - lastScrollTop;
        if (scrollUpDistance < -50) {
          // document.querySelector('#main').classList.remove('is-menu-compacted');
        }
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    },
    false
  );
});
